import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { downtimeGuard } from './common/guards/downtime.guard';
import { groupPermissionGuard } from './common/guards/group-permission.guard';

// Conditional guards: skip MsalGuard and groupPermissionGuard when disableAuth is true
const authGuards = environment.disableAuth ? [] : [MsalGuard, groupPermissionGuard];

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/screening'
  },
  {
    path: 'screening',
    loadComponent: () => import('./components/screening/screening.component').then(c => c.ScreeningComponent),
    canActivate: authGuards,
  },
  {
    path: 'search-for-screening',
    loadComponent: () => import('./components/search-for-screening/search-for-screening.component').then(c => c.SearchForScreeningComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration',
    loadComponent: () => import('./components/administration/administration.component').then(c => c.AdministrationComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/facility',
    loadComponent: () => import('./components/administration/facility/facility.component').then(c => c.FacilityComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/cpt',
    loadComponent: () => import('./components/administration/cpt/cpt.component').then(c => c.CptComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/diagnosis',
    loadComponent: () => import('./components/administration/diagnosis/diagnosis.component').then(c => c.DiagnosisComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/medical-necessity',
    loadComponent: () => import('./components/administration/medical-necessity/medical-necessity.component').then(c => c.MedicalNecessityComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/abn-nnc',
    loadComponent: () => import('./components/administration/abn-nnc/abn-nnc.component').then(c => c.AbnNncComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/users',
    loadComponent: () => import('./components/administration/users/users.component').then(c => c.UsersComponent),
    canActivate: authGuards,
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/online-help',
    loadComponent: () => import('./online-help/online-help.component').then(c => c.OnlineHelpComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/downtime',
    loadComponent: () => import('./downtime/downtime.component').then(c => c.DowntimeComponent),
    canActivate: authGuards,
  },
  {
    path: 'unavailable',
    loadComponent: () => import('./unavailable/unavailable.component').then(c => c.UnavailableComponent),
    canActivate: environment.disableAuth ? [] : [MsalGuard, downtimeGuard]
  },
  {
    path: 'not-authorized',
    loadComponent: () => import('./401/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./404/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  }
];
